import store from "../configureStore";
import allActions from "../actions";
import { actionTypesHubspot } from "../constants/actionTypesHubspot";
import { companyModel } from "../../models/hubspotModel";

const { dispatch } = store;

export const HubspotDispatcher = (
  actionType: actionTypesHubspot,
  data: unknown
) => {
  const hubspotAction = allActions.hubspotActions;

  switch (actionType) {
    case actionTypesHubspot.ListOfCompanies:
      dispatch(hubspotAction.setCompaniesList(data as Array<companyModel>));
      break;
    case actionTypesHubspot.ListOfCompanies:
      dispatch(hubspotAction.setCompaniesList(data as Array<companyModel>));
      break;
    case actionTypesHubspot.FilterCompanies:
      dispatch(hubspotAction.setFilteredCompanies(data as Array<companyModel>));
      break;
    case actionTypesHubspot.SearchCompanies:
      dispatch(hubspotAction.setSearchCompanies(data as Array<companyModel>));
      break;
    case actionTypesHubspot.IsCompaniesTableRefreshed:
      dispatch(hubspotAction.setIsCompaniesTableRefreshed(data as boolean));
      break;
    case actionTypesHubspot.SelectedCompany:
      dispatch(hubspotAction.setSelectedCompany(data as companyModel));
      break;
  }
};
